"use strict";

exports.__esModule = true;
var _CommentTableElement = require("./CommentTableElement");
Object.keys(_CommentTableElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommentTableElement[key]) return;
  exports[key] = _CommentTableElement[key];
});
var _CommentTableFields = require("./CommentTableFields");
Object.keys(_CommentTableFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommentTableFields[key]) return;
  exports[key] = _CommentTableFields[key];
});
var _CommentTableThumbnail = require("./CommentTableThumbnail");
Object.keys(_CommentTableThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommentTableThumbnail[key]) return;
  exports[key] = _CommentTableThumbnail[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});